'use strict';

/** @type {import('./floor')} */
module.exports = Math.floor;



/*****************
 ** WEBPACK FOOTER
 ** ./~/math-intrinsics/floor.js
 ** module id = 725
 ** module chunks = 0
 **/